import { Modal, Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { FaTelegramPlane } from "react-icons/fa";
import { React, useState } from "react";
import axios from "axios";

import { URL_AWS } from "../../../constans/servidor";

const InfoCase = ({ open, onOpen, data }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [responseCase, setResponseCase] = useState("");
  const {
    control,
    formState: { errors },
  } = useForm();

  const formatedDate = (fechaStr) => {
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];

    const fecha = new Date(fechaStr);
    const dia = fecha.getDate();
    const mes = meses[fecha.getMonth()];
    const ano = fecha.getFullYear();

    return `${dia} de ${mes} del ${ano}`;
  };

  const sendResponse = async (data) => {
    setShowLoading(true);
    if (!responseCase) {
      toast.error("Ingrese una respuesta");
      setShowLoading(false);
      return;
    }
    try {
      const dataCase = {
        numberCase: data.case_number,
        responseCase,
      };
      const response = await axios.post(
        // `http://localhost:3000/dev/sendResponseCase`,
        `${URL_AWS}/ContactCategory/sendResponseCase`,
        dataCase
      );
      if (response.data.status === true) {
        toast.success(response.data.message);
        onOpen(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        toast.error(response.data.message);
        setShowLoading(false);
        return;
      }
    } catch (error) {
      toast.error(error.message);
      setShowLoading(false);
      return;
    }
  };

  return (
    <>
      <Modal
        size="md"
        show={open}
        onHide={() => onOpen(false)}
        className="be-modal"
      >
        <Modal.Header>
          <Modal.Title style={{ color: "#008b9c" }}>
            Informarcion del caso N°{" "}
            <b style={{ color: `${data.status !== 1 ? "red" : "#008b9c"}` }}>
              {data.case_number}
            </b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b style={{ color: "#008b9c" }}>{data.city}</b>
          <br />
          {data.complainant_name === "Anónimo" ? (
            <b style={{ color: "#008b9c" }}>Persona Anonima</b>
          ) : (
            <>
              <b style={{ color: "#008b9c" }}>Datos del denunciante</b>
              <p style={{ margin: 0 }}>
                Nombre del denunciante: {data.complainant_name}
              </p>
              <p style={{ margin: 0 }}>
                Correo electronico: {data.complainant_email}
              </p>
              <p style={{ margin: 0 }}>Telefono: {data.complainant_phone}</p>
            </>
          )}
          <br />
          {data.witness_complaint === "false" ? (
            <b style={{ color: "#008b9c" }}>Sin testigos</b>
          ) : (
            <>
              <b style={{ color: "#008b9c" }}>Datos del testigo</b>
              <p style={{ margin: 0 }}>
                Nombre del testigo: {data.witness_name}
              </p>
              <p style={{ margin: 0 }}>
                Telefono del testigo: {data.witness_phone}
              </p>
            </>
          )}
          <br />
          <b style={{ color: "#008b9c" }}>Categoria del caso: </b>
          {data.complaint_category}
          <br />
          <b style={{ color: "#008b9c" }}>Fecha de creacion: </b>
          {formatedDate(data.create_date)}
          <br />
          <b style={{ color: "#008b9c" }}>Estado de la denuncia: </b>
          {data.status === 1
            ? "Aún se encuentra en proceso de evaluación."
            : "Denuncia contestada"}
          <br />
          <b style={{ color: "#008b9c" }}>Relacion con la compañia: </b>
          {data.relationship_with_the_company}
          <br />
          <b style={{ color: "#008b9c" }}>Denuncia enviada: </b>
          {data.detail_complaint}
          <br />
          {data.status === 1 ? (
            <>
              <Form.Group controlId="formBasicPassword">
                <Form.Label>
                  <b style={{ color: "#008b9c" }}>Envie su respuesta</b>
                </Form.Label>
                <Controller
                  name="mensaje"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: {
                      value: true,
                      message: "El mensaje es obligatorio",
                    },
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Form.Control
                      onChange={(data) => {
                        onChange(data);
                        setResponseCase(data.target.value);
                      }}
                      as="textarea"
                      value={value}
                      placeholder="Respuesta de la denuncia"
                      defaultValue=" "
                    />
                  )}
                />
                {errors.mensaje && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    El mensaje es obligatorio
                  </Form.Text>
                )}
              </Form.Group>
              {showLoading ? (
                <div className="container-sniper"></div>
              ) : (
                <>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      style={{ color: "#008b9c" }}
                      onClick={() => sendResponse(data)}
                    >
                      <FaTelegramPlane color="white" className="me-2" />
                    </Button>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <b style={{ color: "#008b9c" }}>Respueta enviada: </b>
              {data.response_case}
            </>
          )}
        </Modal.Body>
        <Button
          onClick={() => onOpen(false)}
          variant="link"
          className="btn-enlace-gris"
          style={{ color: "rgb(144, 212, 0)" }}
        >
          Cancelar
        </Button>
      </Modal>
    </>
  );
};

export default InfoCase;
